/**
 * LoadingSpinner Component
 * A full-screen loading indicator with optional text display
 * Renders a spinning animation with a semi-transparent background overlay
 */

/**
 * LoadingSpinner component that displays a centered loading animation
 * @param {Object} props - Component props
 * @param {boolean} props.isLoading - Controls visibility of the loading spinner
 * @param {string} props.text - Optional text to display below the spinner
 * @returns {JSX.Element|null} Rendered loading spinner or null if not loading
 */
const LoadingSpinner = ({ isLoading, text }) => {
  if (!isLoading) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex flex-col items-center justify-center z-50">
      <div className="w-12 h-12 border-4 border-t-blue-500 border-b-blue-500 border-r-transparent border-l-transparent rounded-full animate-spin" />
      <p className="mt-4 text-white font-medium">{text}</p>
    </div>
  );
};

export default LoadingSpinner;
